import Icon from '@ant-design/icons/lib/components/Icon';
import { Tooltip } from 'antd';
import { useMemo } from 'react';
import { useInputController } from '../../hooks/useInputController.ts';
import { StaticInput } from '../static/StaticInput.tsx';

const BoltSvg = () => (
  <svg
    viewBox="0 0 24 24"
    focusable="false"
    fill="none"
    stroke="#bfbfbf"
    strokeWidth="2"
    strokeLinecap="round"
    strokeLinejoin="round"
    width="1em"
    height="1em"
    aria-hidden="true"
  >
    <path d="M13 3l0 7l6 0l-8 11l0 -7l-6 0l8 -11" />
  </svg>
);

const COMPUTED_SUFFIX = (
  <Tooltip title="Calcolato automaticamente">
    <Icon component={BoltSvg} />
  </Tooltip>
);

export interface IComputedStaticTextInputProps {
  name: string;
  removeBorder?: boolean;
  format?: (value: any) => string;
  /** A differenza di format non modifica il valore nel form ma è applicato solo la label mostrata */
  renderFormat?: (value: any) => string;
  /** Permette di nascondere il componente pur mantenendo attive tutte le logiche */
  hidden?: boolean;
}

/**
 * Renderizza un valore come campo statico, registrandone il riferimento nel form.
 *
 * Il valore nel form state viene aggiornato centralmente da `syncComputedValues`
 * (chiamato nell'onChange di `useInputController`), che esegue `schema.cast()`
 * per risolvere tutti i campi calcolati in un singolo passaggio.
 * Questo componente è quindi un puro reader: legge dal form state e formatta.
 */
export function ComputedStaticTextInput(props: IComputedStaticTextInputProps) {
  const {
    name,
    removeBorder,
    format,
    renderFormat = value => value as string,
    hidden,
  } = props;

  const {
    field: { value },
  } = useInputController(name, { enabled: true, skipComputedSync: true });

  const formattedValue = useMemo(() => {
    if (value == null) return null;
    return format ? format(value) : value;
  }, [value, format]);

  if (hidden) return null;

  return (
    <StaticInput
      value={renderFormat(formattedValue ?? '')}
      removeBorder={removeBorder}
      suffix={COMPUTED_SUFFIX}
      style={{ backgroundColor: '#fafafa' }}
    />
  );
}
